module.exports = __webpack_public_path__ + "img/chickenburger_bite.62564597.jpg";